import React from "react";
import CollapsableWrapper from "../CollapsableWrapper/CollapsableWrapper";
import BasicCompanyData from "../BasicCompanyData/BasicCompanyData";
import AddressData from "../AddressData/AddressData";
import InputComponent from "../../UI/InputComponent/InputComponent";
import Row from "../WrapperComponents/Row";
import Col from "../WrapperComponents/Col";
import ContactInformation from "../ContactInformation/ContactInformation";
import MappedRegistrationComponent from "../MappedRegistrationComponent/MappedRegistrationComponent";
import BasicReviserData from "../BasicReviserData/BasicReviserData";
import AuditCompanyMember from "../AuditCompanyMember/AuditCompanyMember";
import AuditCompanyBoardMember from "../AuditCompanyBoardMember/AuditCompanyBoardMember";
import NetworkMembershipInfo from "../NetworkMembershipInfo/NetworkMembershipInfo";
import NamesAndAddressesNetworkList from "../NamesAndAddressesNetworkList/NamesAndAddressesNetworkList";
import RegistrationComponent from "../RegistrationComponent/RegistrationComponent";
import ButtonComponent from "../../UI/ButtonComponent/ButtonComponent";
import AssociationInfo from "../AssociationInfo/AssociationInfo";
import Dropdown from "../../UI/Dropdown/Dropdown";
const EntryForm7 = (props) => {
  const { basicReviserData, userData } = props.parentState.newFormData;

  const legalFormsOptions = props.parentState.legalForms.map((element) => {
    return (
      <option key={element.sifPOblika} value={element.sifPOblika}>
        {element.opisPOblika}
      </option>
    );
  });

  const mappedBasicReviserData = basicReviserData.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`basic-reviser-data-collapse${index}`}
        clickText={`Ovlašteni revizor ${
          element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
        }`}
      >
        <BasicReviserData
          group="basicReviserData"
          disabled
          required
          id={element.id}
          idZaBtn={index}
          handleFetch={props.getReviserDataByOib}
          {...props}
        />
      </CollapsableWrapper>
    );
  });

  const popuniZagraduAuditCompanyMember = (clan) =>{
    if(clan.oib){
      if(clan.ime && clan.prezime){
        if(clan.naziv) {
          return `(${clan.ime} ${clan.prezime} - ${clan.naziv})`
        }
        return `(${clan.ime} ${clan.prezime})`;
      }else if(clan.naziv){
        return `(${clan.naziv})`;
      }
    }
    return "(Novi unos)";
  }

  const mappedAuditCompanyMember =
    props.parentState.newFormData.auditCompanyMember.map((element, index) => {
      return (
        <CollapsableWrapper
          key={`mapped-audit-company-member-collapse${index}`}
          clickText={`Član/dioničar revizorskog društva ${popuniZagraduAuditCompanyMember(element)}`}
        >
          <AuditCompanyMember id={element.id} idZaBtn={index} {...props} required />
        </CollapsableWrapper>
      );
    });

  const mappedAuditCompanyBoardMember =
    props.parentState.newFormData.auditCompanyBoardMember.map(
      (element, index) => {
        return (
          <CollapsableWrapper
            key={`mapped-audit-company-board-member-collapse${index}`}
            clickText={`Član uprave ili upravnog odbora revizorskog društva ${
              element.ime && element.prezime ? `(${element.ime} ${element.prezime})` : "(Novi unos)"
            }`}
          >
            <AuditCompanyBoardMember
              showBrRegOrig
              id={element.id}
              idZaBtn={index}
              {...props}
              required
            />
          </CollapsableWrapper>
        );
      }
    );

  const { memberInfo } = props.parentState.newFormData;
  const mappedMemberInfo = memberInfo.map((element, index) => {
    return (
      <CollapsableWrapper
        key={`member-info-collapse${index}`}
        clickText={`Popis naziva i adresa društava članova i povezanih društava ${
          memberInfo.length > 1 ? `(${index + 1})` : ""
        }`}
      >
        <NamesAndAddressesNetworkList
          group={"memberInfo"}
          {...props}
          idZaBtn={index}
          id={element.id}
        />
      </CollapsableWrapper>
    );
  });

  const { auditCompanyRegistration } = props.parentState.newFormData;

  const mappedAuditCompanyRegistration = auditCompanyRegistration.map(
    (element, index) => {
      return (
        <CollapsableWrapper
          key={`mapped-audit-company-registration-collapse${index}`}
          clickText={`Registracije revizorskog društva/revizora kod nadležnog tijela drugih država članica i kod nadležnog tijela u trećim zemljama ${
            auditCompanyRegistration.length > 1 ? `(${index + 1})` : ""
          }`}
        >
          <MappedRegistrationComponent
            {...props}
            id={element.id}
            idZaBtn={index}
            onChange={props.mappedUserInputHandler}
            inputValue={props.parentState.newFormData.auditCompanyRegistration}
            group="auditCompanyRegistration"
          />
        </CollapsableWrapper>
      );
    }
  );

  const disableCounty = props.parentState.newFormData.address.sifDrzave
    ? false
    : true;
  const disableCity = props.parentState.newFormData.address.sifZupanije
    ? false
    : true;
  const disableDistrict = props.parentState.newFormData.address.sifGrdOpc
    ? false
    : true;

  return (
    <>
      <CollapsableWrapper clickText="Osnovni podaci">
        <AssociationInfo
          disabled={
            props.parentState.newFormData.oznDokumenta.oznDokumenta !== null &&
            props.parentState.update &&
            props.parentState.newFormData.userData.oznAkt
          }
          required
          {...props}
        />
      </CollapsableWrapper>

      <CollapsableWrapper clickText="Podaci o adresi i registraciji">
        <>
          <AddressData
            permitDateLabel={"Datum odobrenja za rad"}
            permitNumberLabel={"Broj odobrenja za rad"}
            requiredBrPoste
            requiredKbr
            required
            requiredRegistration
            disableDistrict={disableDistrict}
            disableCity={disableCity}
            disableCounty={disableCounty}
            {...props}
          />
          <Row>
            <Col className="col-lg-8 pravnioblik-style">
              <Dropdown
                style={
                  props.parentState.error &&
                  userData.sifPOblika.length < 1 &&
                  "red"
                }
                label={"Pravni oblik*"}
                hidden
                onChange={props.dropdownHandler}
                value={userData.sifPOblika}
                asProperty="select"
                map={legalFormsOptions}
                text="Odaberite pravni oblik"
              />
            </Col>
            <Col>
              {userData.sifPOblika == "999" && (
                <InputComponent
                  style={
                    props.parentState.error &&
                    userData.sifPOblika == "999" &&
                    userData.opisPOblika.length < 1 &&
                    "red"
                  }
                  onChange={props.userInputHandler}
                  objData={{ group: "userData" }}
                  value={userData.opisPOblika}
                  id="opisPOblika"
                  controlLabel={"Opis pravnog oblika*"}
                />
              )}
            </Col>
          </Row>
        </>
      </CollapsableWrapper>

      <CollapsableWrapper clickText="Osoba za kontakt">
        <ContactInformation
          contactInformation={props.parentState.newFormData.contactInformation}
          {...props}
        />
      </CollapsableWrapper>
      {mappedBasicReviserData}
      {mappedAuditCompanyMember}
      {mappedAuditCompanyBoardMember}
      <CollapsableWrapper clickText="Članstvo u mreži">
        <NetworkMembershipInfo showWeb {...props} required />
      </CollapsableWrapper>
      {mappedMemberInfo}
      {mappedAuditCompanyRegistration}
      <ButtonComponent onClick={props.submitHandler}>
        {props.parentState.update ? "Nastavak" : "Nastavak"}
      </ButtonComponent>
    </>
  );
};

export default EntryForm7;
